export type DisplayMode = "light" | "dark"

export const DEFAULT_DISPLAY_MODE = "light"

export const DISPLAY_MODE_SETTING_KEY = "userDisplayMode"
